import React from 'react'

import { Box, NumberBadge, Text } from '@factorialco/deprecated-design-system'

import { Question } from 'modules/questionnaires/lib/types'

export type CustomQuestion = React.ComponentType<{
  question?: Question
  fallback?: React.ReactNode
  children?: React.ReactNode
  position?: number
}>

interface DefaultContentSectionProps {
  position?: number
  title: string
  uuid: string
  description?: string | null
}

interface Props extends DefaultContentSectionProps {
  renderCustomQuestion?: CustomQuestion
  question?: Question
}

const DefaultContentQuestion: React.FC<React.PropsWithChildren<DefaultContentSectionProps>> = ({
  position,
  title,
  description,
  uuid,
  children,
}) => {
  return (
    <Box flexDirection="column" gap="s16">
      <Box gap="s12" id={`question-${uuid}`}>
        <Box flexDirection="row" gap="s12">
          {position && <NumberBadge label={position} />}
          <Text.Normal size="300" weight="medium" color="grey1000" whiteSpace="breakSpaces">
            {title}
          </Text.Normal>
        </Box>
        {description && (
          <Text.Normal size="300" color="grey800" whiteSpace="breakSpaces">
            {description}
          </Text.Normal>
        )}
      </Box>
      <Box width="full">{children}</Box>
    </Box>
  )
}

export const AnswerQuestion: React.FC<React.PropsWithChildren<Props>> = ({
  position,
  title,
  description,
  uuid,
  children,
  renderCustomQuestion: CustomQuestion,
  question,
}) => {
  if (CustomQuestion) {
    return (
      <CustomQuestion
        position={position}
        question={question}
        fallback={
          <DefaultContentQuestion
            position={position}
            title={title}
            description={description}
            uuid={uuid}
          >
            {children}
          </DefaultContentQuestion>
        }
      >
        {children}
      </CustomQuestion>
    )
  }

  return (
    <DefaultContentQuestion position={position} title={title} description={description} uuid={uuid}>
      {children}
    </DefaultContentQuestion>
  )
}
